import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, AtualizarMunicipioIbge } from './types';

export const INITIAL_STATE: AtualizarMunicipioIbge = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): AtualizarMunicipioIbge {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ATUALIZAR_MUNICIPIO_IBGE_REQUEST: {
				draft.status = INITIAL_STATE.status;
				break;
			}

			case Types.ATUALIZAR_MUNICIPIO_IBGE_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}

			case Types.ATUALIZAR_MUNICIPIO_IBGE_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.ATUALIZAR_MUNICIPIO_IBGE_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
